{
  "app.title": "Minitry",
  "auth.description.mock": "Режим mock-входа работает через каноническую границу `apps/web/app/api`.",
  "auth.description.real": "Канонический вход через backend API и сгенерированные контракты в `apps/web/app/api`.",
  "auth.email.label": "Электронная почта",
  "auth.email.placeholder": "name@example.test",
  "auth.error.mock_unavailable": "Сейчас невозможно выполнить вход в mock API режиме.",
  "auth.error.real_unavailable": "Сейчас невозможно выполнить вход через канонический backend API.",
  "auth.loading": "Загрузка данных для входа...",
  "auth.mock.hint": "Mock-аккаунты недоступны. Введите e-mail вручную.",
  "auth.mock.use": "Выбрать",
  "auth.password.label": "Пароль",
  "auth.password.placeholder": "пароль",
  "auth.real.hint": "Включен режим real API. Используйте e-mail и пароль backend-аккаунта.",
  "auth.submit": "Войти",
  "auth.submitting": "Выполняется вход...",
  "auth.title": "Вход",
  "auth.validation.credentials_required": "Требуются электронная почта и пароль.",
  "coffee.description": "Экран aggregate profile для кофейных событий, готовности и связанных стандартных шаблонов через каноническую границу `apps/web/app/api`.",
  "coffee.details.checklists": "Чек-листы",
  "coffee.details.completed": "Выполнено",
  "coffee.details.assignments": "Назначения",
  "coffee.details.empty": "Для этой секции пока нет Coffee-записей.",
  "coffee.details.pending": "Открыто",
  "coffee.details.resources": "Проверки ресурсов",
  "coffee.details.responsibilities": "Ответственности",
  "coffee.details.slots": "Слоты",
  "coffee.details.tasks": "Задачи",
  "coffee.events.active": "Активно",
  "coffee.events.create_description": "Создайте новое кофейное событие отдельно от списка текущих событий.",
  "coffee.events.description": "Выберите кофейное событие, чтобы посмотреть текущую проекцию готовности и связанные рабочие секции.",
  "coffee.events.empty": "Кофейных событий пока нет.",
  "coffee.events.title": "Выбор кофейного события",
  "coffee.navigation.events": "Кофейные события",
  "coffee.navigation.overview": "Обзор",
  "coffee.navigation.participants": "Участники",
  "coffee.navigation.readiness": "Готовность",
  "coffee.navigation.sections": "Секции",
  "coffee.participants.current_event": "Текущее кофейное событие",
  "coffee.participants.description": "Эти участники привязаны напрямую к выбранному кофейному событию.",
  "coffee.participants.empty": "Когда будет выбрано кофейное событие, здесь появится список связанных участников.",
  "coffee.participants.none_assigned": "Для выбранного кофейного события пока не привязано ни одного участника.",
  "coffee.participants.title": "Участники",
  "coffee.role_status.title": "Моя роль в событии",
  "coffee.role_status.description": "Эта карточка показывает, кем вы являетесь в выбранном кофейном событии.",
  "coffee.role_status.none": "Событие не выбрано",
  "coffee.role_status.none_description": "Выберите кофейное событие, чтобы определить вашу роль в нем.",
  "coffee.role_status.leader": "Лидер события",
  "coffee.role_status.participant": "Участник события",
  "coffee.role_status.observer": "Наблюдатель",
  "coffee.assignments.assigned_by": "Назначил",
  "coffee.assignments.none_primary": "Основной состав пока не назначен.",
  "coffee.assignments.none_reserve": "Резерв пока не назначен.",
  "coffee.assignments.participant": "Участник",
  "coffee.assignments.primary": "Основной состав",
  "coffee.assignments.reserve": "Резерв",
  "coffee.assignments.role": "Роль",
  "coffee.assignments.status": "Статус",
  "coffee.assignments.availability": "Доступность",
  "coffee.assignments.fit": "Соответствие",
  "coffee.assignments.fit_match": "Есть Coffee-профиль",
  "coffee.assignments.fit_unmapped": "Нет Coffee-профиля",
  "coffee.assignments.workload": "Нагрузка",
  "coffee.assignments.workload_value": "{count} слотов",
  "coffee.responsibilities.note": "Заметка",
  "coffee.responsibilities.note_placeholder": "Обновить заметку для hand-off или выполнения",
  "coffee.responsibilities.owner": "Ответственный человек",
  "coffee.responsibilities.owner_edit_ready": "Смена owner сохраняет новый `assigneeUserId` прямо в канонической responsibility.",
  "coffee.responsibilities.owner_slot": "Owner-слот",
  "coffee.responsibilities.phase": "Фаза",
  "coffee.responsibilities.phase_unknown": "Неизвестная фаза",
  "coffee.workspace.back": "Назад к Coffee",
  "coffee.workspace.description": "Это отдельное рабочее пространство события для лидера. Здесь можно менять данные события, назначать людей в слоты, распределять ответственности и вести заметки.",
  "coffee.workspace.event_description": "Обновляйте здесь изменяемые поля выбранного coffee-события.",
  "coffee.workspace.assignments_description": "На практике участник добавляется в событие через назначение в слот и роль.",
  "coffee.workspace.participants_description": "Этот список показывает доступных и уже привязанных людей для текущего coffee-события.",
  "coffee.workspace.responsibilities_description": "Здесь можно назначать ответственных, менять статус ответственности и сохранять заметки.",
  "coffee.workspace.no_slots": "Для этого coffee-события пока не материализованы слоты.",
  "coffee.workspace.no_responsibilities": "Для этого coffee-события пока нет ответственностей.",
  "coffee.workspace.not_assigned": "Еще не назначен",
  "coffee.workspace.assignment_note": "Заметка",
  "coffee.workspace.assignment_note_placeholder": "Необязательный контекст для назначения",
  "coffee.workspace.add_assignment": "Сохранить назначение",
  "coffee.workspace.add_responsibility": "Добавить ответственность",
  "coffee.workspace.add_responsibility_description": "Создайте ручную ответственность для этого coffee-события прямо в канонической коллекции event responsibilities.",
  "coffee.workspace.add_responsibility_placeholder": "Например, подготовить дополнительную точку выдачи",
  "coffee.workspace.update_responsibility": "Обновить ответственность",
  "coffee.workspace.save_responsibility": "Сохранить ответственность",
  "coffee.overview.description": "Этот экран остается в рамках ADR: он показывает метаданные модуля и проекцию кофейного дашборда, а операционные пути записи остаются в функциональном core.",
  "coffee.overview.selected_event": "Активное кофейное событие",
  "coffee.overview.title": "Кофейный дашборд",
  "coffee.readiness.description": "Блокирующие проблемы: {blocking} · Предупреждения: {warning}",
  "coffee.readiness.empty_description": "Когда появится кофейное событие, этот экран покажет проекцию готовности поверх slots, assignments, responsibilities, tasks, checklists и resource checks.",
  "coffee.readiness.empty_summary": "Пока не выбрано ни одного кофейного события.",
  "coffee.readiness.meta": "Проекция для события {eventId}",
  "coffee.readiness.meta_empty": "Активная кофейная проекция не загружена.",
  "coffee.readiness.summary": "Текущий кофейный статус: {status}",
  "coffee.readiness.title": "Кофейная готовность",
  "coffee.readiness.workflow_title": "Готовность workflow",
  "coffee.readiness.workflow_description": "Следуйте Coffee-процессу от staffing через ответственности и выполнение до финальной операционной готовности.",
  "coffee.readiness.issue_title": "Проблемы готовности",
  "coffee.readiness.issue_empty": "Сейчас нет открытых блокирующих или предупреждающих проблем готовности.",
  "coffee.readiness.issue_description": "Блокирующие: {blocking} · Предупреждения: {warning}",
  "coffee.readiness.jump_to_stage": "К разделу",
  "coffee.readiness.issue.required_slot_missing_primary": "Как минимум у одного обязательного слота пока нет основного назначения.",
  "coffee.readiness.issue.slot_underfilled": "Один из слотов сейчас недоукомплектован.",
  "coffee.readiness.issue.slot_overfilled": "Один из слотов сейчас переполнен.",
  "coffee.readiness.issue.reserve_without_primary": "У слота есть резерв без основного назначения.",
  "coffee.readiness.issue.primary_assignment_unconfirmed": "Как минимум одно основное назначение еще не подтверждено.",
  "coffee.readiness.issue.reserve_assignment_unconfirmed": "Как минимум одно резервное назначение еще не подтверждено.",
  "coffee.readiness.issue.responsibility_unassigned": "Как минимум одна ответственность пока не назначена человеку.",
  "coffee.readiness.issue.responsibility_incomplete": "Как минимум одна ответственность еще не завершена.",
  "coffee.readiness.issue.task_unassigned": "Как минимум одна задача пока не назначена.",
  "coffee.readiness.issue.task_incomplete": "Как минимум одна задача еще открыта.",
  "coffee.readiness.issue.checklist_incomplete": "Как минимум один пункт чек-листа еще открыт.",
  "coffee.readiness.issue.resource_not_checked": "Как минимум одна проверка ресурсов еще не выполнена.",
  "coffee.readiness.issue.resource_missing": "Как минимум одного ресурса сейчас не хватает.",
  "coffee.readiness.issue.resource_low": "Как минимум один ресурс на исходе.",
  "coffee.workflow.staffing.title": "1. Staffing",
  "coffee.workflow.staffing.description": "Проверьте Coffee-слоты и убедитесь, что основной и резервный состав выставлены осмысленно.",
  "coffee.workflow.staffing.summary": "{count} слотов в staffing-потоке",
  "coffee.workflow.responsibilities.title": "2. Ответственности",
  "coffee.workflow.responsibilities.description": "Пройдите event-bound Coffee-ответственности вместе с owner, фазой, статусом и заметкой.",
  "coffee.workflow.responsibilities.summary": "{count} ответственностей в потоке",
  "coffee.workflow.execution.title": "3. Выполнение",
  "coffee.workflow.execution.description": "Держите задачи и чек-листы синхронизированными, чтобы команда корректно закрывала операционную подготовку.",
  "coffee.workflow.execution.summary": "{tasks} задач · {checklists} чек-листов",
  "coffee.workflow.resources.title": "4. Ресурсы",
  "coffee.workflow.resources.description": "Подтвердите остатки и статус ресурсов до финального допуска Coffee-служения.",
  "coffee.workflow.resources.summary": "{count} проверок ресурсов в потоке",
  "coffee.workflow.final.title": "5. Финальный статус",
  "coffee.workflow.final.description": "Финальный обзор собирает открытые проблемы, завершенные проверки и текущий операционный статус.",
  "coffee.workflow.final.open_issues": "Открытые проблемы",
  "coffee.workflow.final.completed_checks": "Завершенные проверки",
  "coffee.workflow.final.resource_risks": "Ресурсные риски",
  "coffee.workflow.final.operational_state": "Операционный статус",
  "coffee.workflow.final.state_summary": "Итоговый статус: {status}. Этот раздел собирает последние открытые пункты перед операционным hand-off Coffee.",
  "coffee.workflow.final.no_open_issues": "Открытых проблем больше нет. С точки зрения текущей проекции readiness в Coffee не осталось блокеров и предупреждений.",
  "coffee.workflow.final.no_completed_checks": "В closeout пока не видно завершенных пунктов чек-листа.",
  "coffee.workflow.final.no_resource_risks": "Оставшихся ресурсных рисков нет. По текущему состоянию запасов Coffee можно закрывать стабильно.",
  "coffee.reminders.title": "6. Напоминания",
  "coffee.reminders.description": "Подготовьте точечные reminders для открытых ответственностей и рисков по запасам.",
  "coffee.reminders.responsibilities_title": "Reminders по ответственностям",
  "coffee.reminders.resources_title": "Reminders по ресурсам",
  "coffee.reminders.none_responsibilities": "Сейчас ни одной открытой ответственности не нужен reminder.",
  "coffee.reminders.none_resources": "Сейчас ни одной проверке ресурсов не нужен reminder.",
  "coffee.reminders.target_leader": "Цель: лидер",
  "coffee.reminders.target_assignee": "Ответственный человек",
  "coffee.reminders.target_unassigned": "Ответственный человек еще не назначен",
  "coffee.reminders.leader_action": "Напомнить лидеру",
  "coffee.reminders.assignee_action": "Напомнить ответственному",
  "coffee.reminders.contract_ready": "Напоминания теперь идут через канонический event reminder contract и по умолчанию используют предпочтительные каналы уведомлений.",
  "coffee.notifications.title": "Уведомления",
  "coffee.notifications.description": "Здесь собраны event-scoped уведомления для выбранного coffee-события: reminders, обновления статусов и другие записи из канонического notification feed.",
  "coffee.notifications.back_to_workspace": "Назад в workspace",
  "coffee.notifications.open_workspace": "Открыть workspace",
  "coffee.notifications.disabled": "Для этого события capability notifications сейчас не включен.",
  "coffee.notifications.empty": "Для этого события пока нет уведомлений.",
  "coffee.notifications.channels": "Каналы",
  "coffee.notifications.created_at": "Создано",
  "coffee.notifications.sent_at": "Отправлено",
  "coffee.notifications.read_at": "Прочитано",
  "coffee.notifications.not_sent": "еще не отправлено",
  "coffee.notifications.unread": "еще не прочитано",
  "coffee.notifications.open_link": "Открыть ссылку",
  "coffee.actions.mark_complete": "Отметить выполненным",
  "coffee.actions.reopen": "Открыть снова",
  "coffee.actions.update": "Обновить",
  "coffee.details.unassigned": "не назначено",
  "coffee.error.update_failed": "Сейчас не удалось сохранить изменения в Coffee.",
  "coffee.sections.description": "Счетчики показывают, какие core-секции, привязанные к Coffee, доступны в текущей проекции.",
  "coffee.sections.disabled": "Отключено для этого event",
  "coffee.sections.empty": "Coffee-секции пока недоступны.",
  "coffee.sections.enabled": "Активно в проекции",
  "coffee.sections.title": "Покрытие секций",
  "coffee.slots.capacity": "Вместимость",
  "coffee.slots.add_description": "Создайте custom slot для дополнительных участников coffee-команды.",
  "coffee.slots.add_title": "Добавить слот",
  "coffee.slots.code": "Код слота",
  "coffee.slots.code_placeholder": "например, backup_barista",
  "coffee.slots.custom": "Custom",
  "coffee.slots.delete": "Удалить слот",
  "coffee.slots.display_name": "Название слота",
  "coffee.slots.display_name_placeholder": "Например, Backup barista",
  "coffee.slots.is_required": "Слот обязателен",
  "coffee.slots.locked_hint": "Для слотов с назначениями rule-critical поля остаются read-only.",
  "coffee.slots.materialized": "Blueprint",
  "coffee.slots.max_quantity": "Максимум",
  "coffee.slots.min_quantity": "Минимум",
  "coffee.slots.optional": "Необязательно",
  "coffee.slots.required": "Обязательно",
  "coffee.slots.save": "Сохранить слот",
  "coffee.slots.update": "Обновить слот",
  "coffee.title": "Кофейное служение",
  "music.assignments.participant": "Участник",
  "music.assignments.primary": "Основной",
  "music.assignments.reserve": "Резерв",
  "music.assignments.role": "Роль",
  "music.description": "Музыкальный модуль объединяет планирование событий, назначения по слотам и репертуар для worship-команды.",
  "music.details.assignments": "Назначения",
  "music.events.active": "Активно",
  "music.events.create_description": "Создавайте service и rehearsal события для музыкальной команды.",
  "music.events.description": "Выберите музыкальное событие, чтобы открыть его workspace с репертуаром и слотами.",
  "music.events.title": "Музыкальные события",
  "music.notifications.title": "Уведомления",
  "music.participants.description": "Участники с музыкальными назначениями и их availability собираются здесь.",
  "music.participants.empty": "Для музыкального модуля пока нет участников.",
  "music.participants.none_assigned": "В этом музыкальном событии пока нет назначений.",
  "music.participants.title": "Участники",
  "music.repertoire.artist_unknown": "исполнитель неизвестен",
  "music.repertoire.description": "Текущий сетлист события на основе канонического repertoire API.",
  "music.repertoire.empty": "Для этого события пока не выбран репертуар.",
  "music.repertoire.key_unknown": "тональность неизвестна",
  "music.repertoire.kind.primary": "Основной",
  "music.repertoire.kind.reserve": "Резерв",
  "music.repertoire.title": "Репертуар",
  "music.role_status.description": "Показывает, являетесь ли вы лидером музыкального события, участником по слотам или просто наблюдателем.",
  "music.role_status.leader": "Лидер музыки",
  "music.role_status.none": "Событие не выбрано",
  "music.role_status.observer": "Наблюдатель",
  "music.role_status.participant": "Участник музыки",
  "music.role_status.title": "Ваш музыкальный статус",
  "music.notes.title": "Заметки события",
  "music.notes.description": "Собрали заметки, которые уже приходят с backend для music event.",
  "music.notes.empty": "Для этого музыкального события backend пока не вернул заметок.",
  "music.notes.kind.assignment": "Назначение",
  "music.notes.kind.attendance": "Посещаемость",
  "music.notes.kind.checklist": "Чеклист",
  "music.notes.kind.repertoire": "Репертуар",
  "music.notes.kind.task": "Задача",
  "music.error.update_failed": "Сейчас не удалось сохранить изменения в Music.",
  "music.slots.add_description": "Создайте custom slot для дополнительных участников music-команды.",
  "music.slots.add_title": "Добавить слот",
  "music.slots.custom": "Custom",
  "music.slots.delete": "Удалить слот",
  "music.slots.display_name": "Название слота",
  "music.slots.display_name_placeholder": "Например, Choir support",
  "music.slots.is_required": "Слот обязателен",
  "music.slots.locked_hint": "Для слотов с назначениями rule-critical поля остаются read-only.",
  "music.slots.materialized": "Blueprint",
  "music.slots.max_quantity": "Максимум",
  "music.slots.min_quantity": "Минимум",
  "music.slots.optional": "Необязательно",
  "music.slots.required": "Обязательно",
  "music.slots.save": "Сохранить слот",
  "music.slots.update": "Обновить слот",
  "music.title": "Музыкальное служение",
  "music.workspace.add_assignment": "Сохранить назначение",
  "music.workspace.assignment_note": "Заметка",
  "music.workspace.assignment_note_placeholder": "Например, подготовить переход без клика.",
  "music.workspace.assignments_description": "Управляйте слотами worship-команды и назначениями прямо из music workspace.",
  "music.workspace.back": "Назад к музыке",
  "music.workspace.event_description": "Обновляйте детали музыкального события, не выходя из профильного workspace.",
  "music.workspace.no_slots": "Для этого музыкального события пока не материализованы слоты.",
  "music.workspace.not_assigned": "Не назначено",
  "music.workspace.participants_description": "Смотрите всех участников music workspace вместе с ролями и availability.",
  "coffee.status.blocked": "заблокировано",
  "coffee.status.cancelled": "отменено",
  "coffee.status.done": "выполнено",
  "coffee.status.in_progress": "в работе",
  "coffee.status.low": "мало",
  "coffee.status.missing": "отсутствует",
  "coffee.status.not_applicable": "не применяется",
  "coffee.status.not_checked": "не проверено",
  "coffee.status.planned": "запланировано",
  "coffee.status.ready": "готово",
  "coffee.status.todo": "к выполнению",
  "error.400.subtitle": "Если вам кажется, что система ошиблась, пожалуйста, сообщите нам.",
  "error.400.title": "400 — запрос некорректен.",
  "error.403.subtitle": "Этот раздел сейчас доступен только пользователям с ролью admin.",
  "error.403.title": "403 — доступ запрещён.",
  "error.404.subtitle": "Страница \"{pathname}\" недоступна.",
  "error.404.title": "404 — страница не найдена.",
  "error.500.subtitle": "Страница \"{pathname}\" сейчас недоступна.",
  "error.500.title": "500 — что-то пошло не так.",
  "error.go_home": "На главную",
  "error.noscript": "Это приложение работает заметно лучше с включенным JavaScript.",
  "errors.auth.authentication_required": "Для этого действия требуется вход.",
  "errors.auth.invalid_api_token": "Токен доступа недействителен или истек.",
  "errors.auth.invalid_authorization_header": "Заголовок Authorization некорректен.",
  "errors.auth.invalid_credentials": "Неверный e-mail или пароль.",
  "errors.auth.invalid_refresh_token": "Refresh-токен недействителен или был отозван.",
  "errors.auth.rate_limited.login": "Слишком много попыток входа. Попробуйте позже.",
  "errors.request.invalid_payload": "Некорректное тело запроса.",
  "errors.users.locale_unsupported": "Этот язык не поддерживается для пользовательского профиля.",
  "home.navigation.admin": "Админ",
  "home.navigation.coffee": "Кофе",
  "home.navigation.music": "Музыка",
  "events.actions.edit": "Редактировать",
  "events.actions.cancel": "Отмена",
  "events.actions.update": "Обновить событие",
  "events.create.description": "Создавайте новые события прямо через канонический Events API.",
  "events.create.submit": "Создать событие",
  "events.create.submitting": "Событие создается...",
  "events.create.title": "Новое событие",
  "events.description": "Этот экран читает события из функционального core и теперь позволяет создавать и редактировать их через канонические event-эндпоинты.",
  "events.edit.description": "Обновляйте поддерживаемые контрактом поля выбранного события.",
  "events.edit.empty": "Выберите событие слева, чтобы редактировать его данные.",
  "events.edit.submit": "Сохранить событие",
  "events.edit.submitting": "Событие сохраняется...",
  "events.edit.title": "Выбранное событие",
  "events.error.save_failed": "Сейчас не удалось сохранить событие.",
  "events.chat.compose": "Новое сообщение",
  "events.chat.delete": "Удалить сообщение",
  "events.chat.deleting": "Сообщение удаляется...",
  "events.chat.description": "Работайте напрямую с каноническими чат-сообщениями выбранного события.",
  "events.chat.disabled": "Чат не включен для этого профиля события.",
  "events.chat.edit": "Редактировать сообщение",
  "events.chat.empty": "Когда событие будет выбрано, здесь появится его канонический чат.",
  "events.chat.list_empty": "Для этого события пока нет сообщений.",
  "events.chat.pinned": "Закреплено",
  "events.chat.placeholder": "Поделитесь коротким сообщением для команды события...",
  "events.chat.submit": "Отправить сообщение",
  "events.chat.submitting": "Сообщение отправляется...",
  "events.chat.title": "Чат события",
  "events.chat.update": "Сохранить сообщение",
  "events.chat.updating": "Сообщение сохраняется...",
  "events.field.aggregate_profile": "Профиль агрегата",
  "events.field.blueprint_version": "Версия blueprint",
  "events.field.ends_at": "Окончание",
  "events.field.event_type": "Тип события",
  "events.field.group": "Группа",
  "events.field.leader": "Ответственный лидер",
  "events.field.location": "Место",
  "events.field.scope": "Область события",
  "events.field.starts_at": "Начало",
  "events.field.status": "Статус",
  "events.field.title": "Название",
  "events.participants.title": "Участники",
  "events.participants.description": "Фильтруйте людей по назначенной роли, доступности и при необходимости по ministry-контексту.",
  "events.participants.empty": "Сейчас нет участников, подходящих под выбранные фильтры.",
  "events.participants.filters.availability": "Доступность",
  "events.participants.filters.all_availability": "Любая доступность",
  "events.participants.filters.no_availability": "Нет доступности",
  "events.participants.filters.ministry": "Ministry",
  "events.participants.filters.all_ministries": "Все ministries",
  "events.participants.filters.role": "Назначенная роль",
  "events.participants.filters.all_roles": "Все назначенные роли",
  "events.participants.meta.availability": "Доступность",
  "events.participants.meta.assignment_role": "Назначенная роль",
  "events.participants.meta.no_ministry": "Нет привязки к ministry",
  "events.participants.meta.primary": "Основной состав",
  "events.participants.meta.reserve": "Резерв",
  "events.role_status.title": "Моя роль в событии",
  "events.role_status.description": "Эта карточка показывает, кем вы являетесь в выбранном событии.",
  "events.role_status.none": "Событие не выбрано",
  "events.role_status.none_description": "Выберите событие, чтобы определить вашу роль в нем.",
  "events.role_status.leader": "Лидер события",
  "events.role_status.participant": "Участник события",
  "events.role_status.observer": "Наблюдатель",
  "events.role_status.account_role": "Роль аккаунта",
  "events.list.title": "Список событий",
  "events.list.scoped_summary": "{count} текущих событий в профиле {profile}",
  "events.notice.created": "Событие создано.",
  "events.notice.assignment_created": "Назначение сохранено.",
  "events.notice.assignment_updated": "Назначение обновлено.",
  "events.notice.updated": "Событие обновлено.",
  "events.option.cancelled": "Отменено",
  "events.option.coffee": "Кофе",
  "events.option.completed": "Завершено",
  "events.option.confirmation_in_progress": "Идет подтверждение",
  "events.option.confirmed": "Подтверждено",
  "events.option.draft": "Черновик",
  "events.option.kids": "Дети",
  "events.option.media": "Медиа",
  "events.option.meeting": "Встреча",
  "events.option.music": "Музыка",
  "events.option.needs_attention": "Требует внимания",
  "events.option.leaders": "Лидеры",
  "events.option.participants": "Участники",
  "events.option.profile_wide": "На весь профиль",
  "events.option.published": "Опубликовано",
  "events.option.rehearsal": "Репетиция",
  "events.option.service": "Служение",
  "events.option.simple": "Простой",
  "events.option.structured": "Структурированный",
  "events.option.group_scoped": "В рамках группы",
  "events.assignment_status.awaiting_response": "Ожидает ответа",
  "events.assignment_status.cancelled": "Отменено",
  "events.assignment_status.confirmed": "Подтверждено",
  "events.assignment_status.declined": "Отклонено",
  "events.assignment_status.expired": "Истекло",
  "events.assignment_status.planned": "Запланировано",
  "events.assignment_status.replaced": "Заменено",
  "events.assignment_role.primary": "Основной",
  "events.assignment_role.reserve": "Резерв",
  "events.assignment_action.cancel": "Отменить назначение",
  "events.assignment_action.confirm": "Подтвердить",
  "events.assignment_action.decline": "Отклонить",
  "events.group.none_available": "Нет доступных групп",
  "events.scope.group_scoped": "В рамках группы",
  "events.scope.group_scoped_description": "Это событие использует конкретную группу внутри выбранного профиля агрегата.",
  "events.scope.profile_wide": "На весь профиль",
  "events.scope.profile_wide_description": "Это событие относится ко всему выбранному профилю агрегата и не привязано к отдельной группе.",
  "events.placeholder.location": "Главный зал",
  "events.placeholder.title": "Воскресное богослужение",
  "events.readiness.blocking": "Блокирующие",
  "events.readiness.capabilities": "Проверенные возможности",
  "events.readiness.description": "Для выбранного события загружается канонический отчет о готовности из Events core.",
  "events.readiness.empty": "Когда событие будет выбрано, здесь появится канонический отчет о готовности.",
  "events.readiness.issues": "Проблемы готовности",
  "events.readiness.no_issues": "Для этого события сейчас не обнаружено проблем готовности.",
  "events.readiness.none": "Пока ничего не проверено",
  "events.readiness.title": "Отчет о готовности",
  "events.readiness.warning": "Предупреждения",
  "events.validation.invalid_payload": "Проверьте поля события и попробуйте снова.",
  "events.polls.already_voted": "Ваш голос для этого опроса уже записан.",
  "events.polls.close": "Закрыть опрос",
  "events.polls.closes_at": "Закрывается",
  "events.polls.closing": "Опрос закрывается...",
  "events.polls.create": "Создать опрос",
  "events.polls.creating": "Опрос создается...",
  "events.polls.delete": "Удалить опрос",
  "events.polls.deleting": "Опрос удаляется...",
  "events.polls.description": "Работайте напрямую с каноническими опросами выбранного события.",
  "events.polls.disabled": "Опросы не включены для этого профиля события.",
  "events.polls.edit": "Редактировать опрос",
  "events.polls.empty": "Когда событие будет выбрано, здесь появятся его канонические опросы.",
  "events.polls.list_empty": "Для этого события пока нет опросов.",
  "events.polls.multiple_choice": "Разрешить множественный выбор",
  "events.polls.option_four": "Вариант 4",
  "events.polls.option_one": "Вариант 1",
  "events.polls.option_three": "Вариант 3",
  "events.polls.option_two": "Вариант 2",
  "events.polls.pinned": "Закреплено",
  "events.polls.question": "Вопрос",
  "events.polls.question_placeholder": "Кто может помочь после события с уборкой?",
  "events.polls.status.closed": "Закрыт",
  "events.polls.status.deleted": "Удален",
  "events.polls.status.open": "Открыт",
  "events.polls.title": "Опросы события",
  "events.polls.update": "Сохранить опрос",
  "events.polls.updating": "Опрос сохраняется...",
  "events.polls.visibility": "Видимость",
  "events.polls.vote": "Проголосовать",
  "events.polls.voting": "Голос сохраняется...",
  "events.attendance.action.mark_status": "Отметить как {status}",
  "events.attendance.add": "Добавить участие",
  "events.attendance.description": "Используйте канонические участия, чтобы приглашать людей, отмечать участие и поддерживать события с simple profile.",
  "events.attendance.empty": "Для этого события пока не добавлено ни одного участия.",
  "events.attendance.add_selected": "Добавить выбранные участия",
  "events.attendance.field.initial_status": "Начальный статус",
  "events.attendance.field.kind": "Тип участия",
  "events.attendance.field.participant": "Участник",
  "events.attendance.flow.assignment_and_attendance": "Это событие поддерживает и участие в событии, и назначения по слотам.",
  "events.attendance.flow.attendance_only": "В этом событии участие является основным способом управления участниками.",
  "events.attendance.kind.attendee": "Участник",
  "events.attendance.kind.audience": "Аудитория",
  "events.attendance.kind.guest": "Гость",
  "events.attendance.kind.listener": "Слушатель",
  "events.attendance.kind.other": "Другое",
  "events.attendance.kind.regular_attendee": "Постоянный участник",
  "events.attendance.kind.visitor": "Посетитель",
  "events.attendance.none_available": "Нет доступных участников",
  "events.attendance.remove": "Убрать",
  "events.attendance.save_status": "Сохранить статус участия",
  "events.attendance.select_all": "Выбрать всех",
  "events.attendance.selected_empty": "Выберите слева несколько человек, чтобы добавить их одной отправкой.",
  "events.attendance.selected_title": "Выбранные участники ({count})",
  "events.attendance.selection_help": "Выберите несколько человек. Тип участия и начальный статус применяются при выборе и могут быть изменены отдельно для каждого человека перед сохранением.",
  "events.attendance.deselect_all": "Снять выбор со всех",
  "events.attendance.slots_disabled": "Для этого профиля слоты не включены, поэтому управление участниками выполняется ниже через участия.",
  "events.attendance.source.assignment": "Назначение",
  "events.attendance.source.group": "Группа",
  "events.attendance.source.import": "Импорт",
  "events.attendance.source.manual": "Вручную",
  "events.attendance.source.registration": "Регистрация",
  "events.attendance.status.attended": "Присутствовал",
  "events.attendance.status.cancelled": "Отменено",
  "events.attendance.status.declined": "Отклонено",
  "events.attendance.status.going": "Придет",
  "events.attendance.status.invited": "Приглашен",
  "events.attendance.title": "Участие в событии",
  "events.workspace.assignments": "Назначения",
  "events.workspace.capabilities": "Возможности workspace",
  "events.workspace.description": "Эта проекция показывает каноническую сводку workspace для выбранного события.",
  "events.workspace.empty": "Когда событие будет выбрано, здесь появится его workspace-проекция.",
  "events.workspace.slots": "Слоты",
  "events.workspace.timeline": "Таймлайн",
  "events.workspace.timeline_empty": "Для этого события пока нет записей таймлайна.",
  "events.workspace.title": "Workspace события",
  "home.navigation.events": "События",
  "home.navigation.features": "Фичи",
  "home.navigation.home": "Главная",
  "home.navigation.members": "Участники",
  "home.navigation.notifications": "Уведомления",
  "home.navigation.profile": "Профиль",
  "home.navigation.timeline": "Таймлайн",
  "home.section.events": "События",
  "home.section.members": "Участники",
  "home.welcome": "С возвращением, {name}",
  "admin.title": "Администрирование",
  "admin.description": "Этот маршрут собирает уже существующие во фронтенде административные точки входа и ограничивается возможностями, доступными в backend.",
  "admin.meta.current_role": "Текущая роль",
  "admin.meta.api_mode": "Режим API",
  "admin.overview.title": "Обзор",
  "admin.overview.description": "Быстрые показатели на основе уже доступных payload событий и пользователей.",
  "admin.overview.empty": "События пока недоступны.",
  "admin.metric.events_total": "Всего событий",
  "admin.metric.events_published": "Опубликованные события",
  "admin.metric.events_draft": "Черновики",
  "admin.metric.participants_known": "Известные участники",
  "admin.metric.coffee_events": "События Coffee",
  "admin.workflows.title": "Доступные админ-потоки",
  "admin.workflows.description": "Эти ссылки ведут к уже реализованным административным экранам во фронтенде.",
  "admin.workflows.events_title": "Управление событиями",
  "admin.workflows.events_description": "Создавайте и редактируйте события, фильтруйте их по статусу и просматривайте известных участников.",
  "admin.workflows.open_events": "Открыть события",
  "admin.workflows.coffee_title": "Проверить модуль Coffee",
  "admin.workflows.coffee_description": "Откройте экран Coffee для модульных статусов и процессов готовности.",
  "admin.workflows.open_coffee": "Открыть Coffee",
  "admin.workflows.profile_title": "Управление своим профилем",
  "admin.workflows.profile_description": "Проверьте пользовательские и языковые настройки, которые сейчас поддерживает фронтенд.",
  "admin.workflows.open_profile": "Открыть профиль",
  "navigation.mobile.collapse": "Скрыть навигацию",
  "navigation.mobile.expand": "Открыть навигацию",
  "planning.current_session": "Текущая API-сессия",
  "planning.event_badge.count": "Канонических событий: {count}",
  "planning.event_badge.empty": "Канонических событий пока нет",
  "planning.loading": "Рабочее пространство загружается...",
  "planning.no_events": "Канонических событий пока нет.",
  "planning.no_members": "Участники пока не найдены.",
  "planning.session.description": "Вы вошли через режим API {mode}. Этот маршрут защищен root session guard и читает канонические данные через `apps/web/app/api`, а не через прямую mock-проводку.",
  "planning.sign_out": "Выйти",
  "planning.workspace_timeline": "Таймлайн рабочего пространства",
  "planning.workspace_timeline.empty": "Для текущего event workspace пока нет канонических записей таймлайна.",
  "profile.account.description": "Редактируются только те поля, которые уже поддерживаются каноническим контрактом `Users`.",
  "profile.account.title": "Данные аккаунта",
  "profile.back_home": "Вернуться на главную workspace",
  "profile.channel.email": "E-mail",
  "profile.channel.push": "Push",
  "profile.channel.telegram": "Telegram",
  "profile.description": "Этот маршрут остается в рамках ADR: чтение и запись идут только через `GET/PATCH /users/me`, а aggregate profile не смешиваются с пользовательским профилем.",
  "profile.empty.description": "Не удалось загрузить текущий профиль пользователя.",
  "profile.error.save_failed": "Сейчас не удалось сохранить профиль.",
  "profile.field.display_name": "Отображаемое имя",
  "profile.field.email": "E-mail",
  "profile.field.locale": "Язык",
  "profile.field.notifications": "Уведомления",
  "profile.field.notifications_enabled": "Включить уведомления",
  "profile.field.role": "Роль",
  "profile.form.note": "Группы, инструменты и специализации пока остаются только для чтения, пока для них нет отдельных канонических lookup-потоков.",
  "profile.locale.de": "Немецкий",
  "profile.locale.ru": "Русский",
  "profile.meta.api_mode": "Режим API: {mode}",
  "profile.meta.locale": "Язык: {locale}",
  "profile.meta.title": "Канонические метаданные",
  "profile.meta.user_id": "ID пользователя",
  "profile.notifications.description": "Предпочтения сохраняются как часть функционального `Users`-core, а не внутри ministry-specific profile.",
  "notifications.index.title": "Уведомления по событиям",
  "notifications.index.description": "Здесь можно перейти в уведомления конкретного события для {name}.",
  "notifications.index.events_title": "События",
  "notifications.index.events_description": "Выберите событие, чтобы открыть его event-scoped notification feed.",
  "notifications.index.empty": "Событий для просмотра уведомлений пока нет.",
  "notifications.index.open_event": "Открыть уведомления события",
  "notifications.event.title": "Уведомления события",
  "notifications.event.back": "Назад к списку уведомлений",
  "notifications.event.open_workspace": "Открыть workspace",
  "notifications.event.disabled": "Для этого события capability notifications сейчас не включен.",
  "notifications.event.empty": "Для этого события пока нет уведомлений.",
  "notifications.event.channels": "Каналы",
  "notifications.event.created_at": "Создано",
  "notifications.event.sent_at": "Отправлено",
  "notifications.event.read_at": "Прочитано",
  "notifications.event.not_sent": "еще не отправлено",
  "notifications.event.unread": "еще не прочитано",
  "notifications.event.open_link": "Открыть ссылку",
  "features.title": "Карта фич по модулям",
  "features.description": "Здесь показано, какие возможности event modules уже реализованы и какие пока еще не подключены для {name}.",
  "features.status.implemented": "реализовано",
  "features.status.not_implemented": "не реализовано",
  "profile.preferences.description": "Locale и каналы уведомлений обновляются через route action и синхронизируются с backend-контрактом.",
  "profile.preferences.title": "Предпочтения",
  "profile.read_only.description": "Эти поля приходят прямо из канонического user payload. Маршрут не придумывает для них дополнительные lookup-модели.",
  "profile.read_only.empty.groups": "Группы пока не указаны.",
  "profile.read_only.empty.instruments": "Инструменты пока не указаны.",
  "profile.read_only.empty.specializations": "Специализации пока не указаны.",
  "profile.read_only.group_ids": "ID групп",
  "profile.read_only.instrument_ids": "ID инструментов",
  "profile.read_only.specializations": "Специализации",
  "profile.read_only.title": "Поля контракта только для чтения",
  "profile.saved": "Профиль сохранен.",
  "profile.state.empty.description": "Этот экран ожидает аутентифицированного пользователя из функционального `Users`-core.",
  "profile.state.empty.summary": "Профиль недоступен.",
  "profile.state.error.description": "Маршрут остается доступным, но последняя попытка сохранения не получила успешного ответа от backend.",
  "profile.state.error.summary": "Изменения профиля не удалось применить.",
  "profile.state.loading.description": "Маршрут ожидает канонический payload `users/me`.",
  "profile.state.loading.summary": "Профиль пользователя загружается...",
  "profile.state.meta": "Активный режим API: {mode}",
  "profile.state.ready.description": "Запись идет через route action и `PATCH /users/me`, без profile-specific обходных путей.",
  "profile.state.ready.summary": "Профиль пользователя и предпочтения доступны.",
  "profile.state.title": "Состояние профиля",
  "profile.submit": "Сохранить профиль",
  "profile.submitting": "Профиль сохраняется...",
  "profile.title": "Профиль пользователя",
  "profile.validation.display_name_required": "Требуется отображаемое имя.",
  "errors.polls.vote_already_recorded": "Ваш голос для этого опроса уже был записан.",
  "errors.capability.not_enabled": "Эта функция не включена для данного профиля события.",
  "errors.validation.min_items": "Добавьте как минимум два варианта ответа.",
  "shared.language.de": "DE",
  "shared.language.label": "Язык",
  "shared.language.ru": "RU",
  "events": {
    "admin": {
      "empty": "Выберите событие, чтобы открыть административное рабочее пространство.",
      "forbidden": "Эта административная функция недоступна для вашей текущей роли или этого события.",
      "read_only": "Этот раздел доступен для вашей текущей роли только для чтения.",
      "assignments": {
        "title": "Управление назначениями",
        "description": "Управляйте слотами, проверяйте кандидатов и обновляйте статусы назначений прямо в workspace события.",
        "empty": "Для этого события пока нет доступных слотов.",
        "no_candidates": "Для этого слота сейчас нет доступных кандидатов для планирования.",
        "none": "Для этого слота пока нет назначений.",
        "optional": "Необязательно",
        "required": "Обязательно",
        "create": "Создать назначение",
        "update": "Сохранить статус",
        "capacity": "Мин {min} · Макс {max}"
      },
      "availability": {
        "title": "Доступность участников",
        "description": "Проверяйте каноническую доступность кандидатов и уже назначенных участников.",
        "empty": "Для этого участника сейчас нет периодов доступности.",
        "none_selected": "Выберите участника выше, чтобы посмотреть его доступность."
      },
      "repertoire": {
        "title": "Управление репертуаром",
        "description": "Поддерживайте репертуар события через канонический каталог песен и интерфейс репертуара события.",
        "no_tags": "Без тегов",
        "primary": "Основной",
        "reserve": "Резерв",
        "unavailable": "Для этого события функция репертуара не включена.",
        "unknown_artist": "Неизвестный исполнитель",
        "update": "Сохранить репертуар",
        "version": "Версия"
      }
    },
    "assignment_role": {
      "primary": "Основной",
      "reserve": "Резерв"
    },
    "assignment_status": {
      "planned": "Запланировано",
      "awaiting_response": "Ожидает ответа",
      "confirmed": "Подтверждено",
      "declined": "Отклонено",
      "expired": "Истекло",
      "replaced": "Заменено",
      "cancelled": "Отменено"
    },
    "availability_kind": {
      "unavailable": "Недоступен",
      "busy": "Занят",
      "preferred": "Предпочтительно доступен"
    },
    "create": {
      "short": "Создать новое событие"
    },
    "filters": {
      "status": "Фильтр по статусу",
      "all_statuses": "Все статусы"
    },
    "participants": {
      "title": "Участники",
      "description": "Все доступные участники с фильтрами по доступности и типу служения.",
      "empty": "Ни один участник не подходит под текущие фильтры.",
      "filters": {
        "availability": "Доступность",
        "all_availability": "Любая доступность",
        "no_availability": "Доступность не указана",
        "ministry": "Тип служения",
        "all_ministries": "Все типы служения"
      },
      "meta": {
        "ministries": "Типы служения",
        "no_ministry": "Не привязан",
        "availability": "Доступность"
      },
      "event": {
        "empty": "Для этого события сейчас нет подходящих участников.",
        "assign_after_create": "Участники назначаются по слотам.",
        "assign_after_create_description": "После создания события вы сможете назначать участников через канонический Assignments API с event_id и slot_id.",
        "assignment_based": "Участники этого события управляются через назначения по слотам.",
        "add_label": "Добавить участников",
        "add": "Добавить",
        "available_title": "Доступные участники",
        "any_type": "Для этого неагрегированного события можно выбирать участников любого типа.",
        "ministry_scoped": "Для этого события в первую очередь показываются участники подходящего служения.",
        "none_available": "Больше нет доступных участников",
        "none_selected": "К этому событию пока не добавлены участники.",
        "no_slots": "Для этого события пока нет слотов, к которым можно назначать участников.",
        "remove": "Удалить",
        "select_hint": "Выбор и снятие выбора в этом списке добавляет участников и удаляет их из события.",
        "temporary_select_hint": "Пока эта выборка отображается только во фронтенде, пока для события не появятся слоты для назначения.",
        "selected_count": "Выбрано: {count}"
      },
      "slot": {
        "add": "Участник для этого слота",
        "assign": "Назначить участника",
        "capacity": "Мин {min} · Макс {max}",
        "no_candidates": "Для этого слота сейчас нет доступных кандидатов.",
        "none_assigned": "К этому слоту пока никто не назначен.",
        "required": "Обязательно",
        "role": "Роль назначения",
        "unlimited": "без лимита"
      }
    },
    "field": {
      "participants": "Участники"
    }
  }
}
